import React from "react";
// import useItemsEnumerator from "../hooks/useItemsEnumerator";
import ItemsEnumerator from "../components/ItemsEnumerator";

export default function ItemsEnumeratorInterface(props) {
  const {
    values,
    title,
    type,
    multipleChoice,
    canDelete,
    onChange,
    onDelete,
    onEdit,
  } = props;

  return (
    <ItemsEnumerator
      values={values}
      title={title}
      type={type}
      multipleChoice={multipleChoice}
      canDelete={canDelete}
      onChange={onChange}
      onDelete={onDelete}
      onEdit={onEdit}
    />
  );
}
